export default [
  {
    type: "monthly",
    year: 2021,
    month: 1,
    btc: 0,
    source: ""
  },
  {
    type: "monthly",
    year: 2021,
    month: 2,
    btc: 0,
    source: ""
  },
  {
    type: "monthly",
    year: 2021,
    month: 3,
    btc: 0,
    source: ""
  },
  {
    type: "monthly",
    year: 2021,
    month: 4,
    btc: 64,
    source: "https://www.hiveblockchain.com/news/hive-blockchain-achieves-1-exahash-in-bitcoin-mining/"
  },
  {
    type: "monthly",
    year: 2021,
    month: 5,
    btc: 73,
    source: "https://www.hiveblockchain.com/news/hive-blockchain-achieves-1-exahash-in-bitcoin-mining/"
  },
  {
    type: "monthly",
    year: 2021,
    month: 6,
    btc: 86,
    source: "https://www.hiveblockchain.com/news/hive-blockchain-achieves-1-exahash-in-bitcoin-mining/"
  },
  {
    type: "monthly",
    year: 2021,
    month: 7,
    btc: 200,
    source: "https://www.hiveblockchain.com/news/hive-blockchain-achieves-1-exahash-in-bitcoin-mining/"
  },
  {
    type: "monthly",
    year: 2021,
    month: 8,
    btc: 234,
    source: "https://www.hiveblockchain.com/news/hive-blockchain-orders-3000-microbt-high-performance-bitcoin-miners-and-mines-its-1000th-green-and-clean-bitcoin-to-hodl/"
  },
  {
    type: "monthly",
    year: 2021,
    month: 9,
    btc: 221,
    source: "https://www.hiveblockchain.com/news/hive-achieves-record-quarterly-revenue-of-372-million-and-earnings-of-186-million-for-q1-f2022/"
  },
  {
    type: "monthly",
    year: 2021,
    month: 10,
    btc: 0,
    source: ""
  },
  {
    type: "monthly",
    year: 2021,
    month: 11,
    btc: 0,
    source: ""
  },
  {
    type: "monthly",
    year: 2021,
    month: 12,
    btc: 0,
    source: ""
  },
  /* Quarterly */
  {
    type: "quarterly",
    year: 2020,
    quarter: 1,
    btc: 0,
    source: ""
  },
  {
    type: "quarterly",
    year: 2020,
    quarter: 2,
    btc: 0,
    source: ""
  },
  {
    type: "quarterly",
    year: 2020,
    quarter: 3,
    btc: 0,
    source: ""
  },
  {
    type: "quarterly",
    year: 2020,
    quarter: 4,
    btc: 0,
    source: ""
  },
  {
    type: "quarterly",
    year: 2021,
    quarter: 1,
    btc: 0,
    source: ""
  },
  {
    type: "quarterly",
    year: 2021,
    quarter: 2,
    btc: 0,
    source: ""
  },
  {
    type: "quarterly",
    year: 2021,
    quarter: 3,
    btc: 0,
    source: ""
  },
  {
    type: "quarterly",
    year: 2021,
    quarter: 4,
    btc: 0,
    source: ""
  },
]
